import React from 'react';
import cn from 'classnames';

import styles from './circle-button.module.scss';
import { Maybe, noop } from '@crocodille/common';

export interface CircleButtonProps {
  readonly label: string;
  readonly className?: Maybe<string>;
  readonly hiddenLabel?: boolean;
  onClick?(): void;
  readonly inverse?: boolean;
  readonly secondary?: boolean;
  readonly basic?: boolean;
}

const CircleButton: React.FC<React.PropsWithChildren<CircleButtonProps>> = ({
  children,
  label,
  className,
  hiddenLabel = false,
  onClick = noop,
  inverse = false,
  secondary = false,
  basic = false,
}) => {
  return (
    <button
      className={cn(
        styles.container,
        {
          [styles.isHiddenLabel]: hiddenLabel,
          [styles.isInverse]: inverse,
          [styles.isSecondary]: secondary,
        },
        className,
      )}
      aria-label={label}
      onClick={onClick}
    >
      <div
        className={cn(styles.button, {
          [styles.isBasic]: basic,
          [styles.isInverse]: inverse,
        })}
      >
        {children}
      </div>
      {!hiddenLabel ? <span className={styles.label}>{label}</span> : null}
    </button>
  );
};

export default CircleButton;
